module.exports = __webpack_public_path__ + "media/images/saiba_mais01-7a99b33c08e9fb71f02c8c415d1ffc33.png";